import _ from "lodash";

export const payloadIdentity = name => payload => ({ [name]: payload });

export const loadingMutation = ({ name, type }) => (state, action) => ({
  ...state,
  [`loading${name}`]: type === "loading",
  [`failure${name}`]: type === "failure" ? action.payload.failMessage : null,
  [`success${name}`]: type === "success"
});

export const simplePayloadMutation = (state, { payload }) => ({
  ...state,
  ...payload
});

export const resetMutation = initialState => (state, { payload = {} }) => ({
  ...state,
  ..._.omit(initialState, payload.toOmit)
});
